import parse from 'utils/parse';

const makeTestId = (...ids: string[]): string => parse.toTestId('landing', 'what-you-get-banner', ...ids);

const testId = Object.freeze({
  component: makeTestId(),
  expandButton: makeTestId('expand-button'),
  expandedEquation: makeTestId('expanded-equation'),
});

const config = {
  pctRevenueShare: 0.8,
  pctReferBonus: 0.2,
  memberPurchase: 500,
  trafficPct: -0.3,
  trafficAmount: 150,
  feesPct: -0.1,
  feesAmount: 50,
  shareCosts: 300,
  ljSharePct: -0.2,
  ljShareAmount: 60,
  earnUpToPct: 0.8,
  earnUpToAmount: 240,
  referralPct: 0.2,
};

export { testId, config };
